import { logger } from '../utils/logger';
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from '../api/axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // SECURITY FIX (CVE-003): Removed localStorage token check
    // Auth state is now managed by checking API response with httpOnly cookie
    // Initial load will show logged-out, then verify session via API call if needed
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post('/auth/login', { username, password });
      // SECURITY FIX (CVE-003): No longer extract token from response
      // JWT is automatically set as httpOnly cookie by server
      const { admin } = response.data;

      // Only store admin data in React state (not localStorage)
      setAdmin(admin);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed'
      };
    }
  };

  const logout = async () => {
    // SECURITY FIX (CVE-003): Call backend to clear httpOnly cookie
    try {
      await axios.post('/auth/logout');
    } catch (error) {
      logger.error('Logout error:', error);
    }
    // Clear React state
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

